import { configInstance } from '@core/configuracao/nsj-config';
import {
    ValidarAssinaturaApiResponse,
    ValidarAssinaturaHttpResult
} from './validar-assinatura.model';

const FILE_FIELD_NAME = 'arquivo';

class ValidarAssinaturaService {
    async verificarAssinatura(file: File): Promise<ValidarAssinaturaHttpResult> {
        const verifierUrl = this.getVerifierUrl();

        if (!verifierUrl) {
            return {
                statusCode: 500,
                body: {
                    msg: 'URL do serviço de assinatura não configurada.'
                }
            };
        }

        const formData = new FormData();
        formData.append(FILE_FIELD_NAME, file, file.name);

        const response = await fetch(
            verifierUrl,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json'
                },
                body: formData
            }
        );

        return {
            statusCode: response.status,
            body: await this.parseResponseBody(response)
        };
    }

    private getVerifierUrl(): string {
        const baseUrl = configInstance.config?.assinatura?.url || '';

        if (!baseUrl) {
            return '';
        }

        return `${baseUrl.replace(/\/$/, '')}/verificar`;
    }

    private async parseResponseBody(response: Response): Promise<ValidarAssinaturaApiResponse | null> {
        try {
            return await response.json();
        } catch (error) {
            return null;
        }
    }
}

export const validarAssinaturaService = new ValidarAssinaturaService();
